import React, {Component} from "react";
import {Button, Card, Col, Alert, Badge} from 'reactstrap'
//import {vote} from '../../../../../dbFunction/ManagementSystem/CMS/CreateCourse/LearningObjectDisplay/set'
import Chart from 'react-google-charts';
import classes from "./PollDisplay.module.css";
import firebase from "../../Config/firebase";
import {MDBAlert, MDBBtn, MDBBtnGroup, MDBCard} from "mdbreact";
import {isAuth} from "../../Utils/firebaseUtils";
import {Link} from "react-router-dom";
//import * as Get from "../../../../../dbFunction/ManagementSystem/LOMS/Course/get";
const db = firebase.firestore()

class PollDisplay extends Component {
    constructor(props) {
        super(props)


        this.state = {
            voted: false,
            isLoaded: false,
            pollOption: [],
            chartData: [],
            voteSuccess: false,
            pollTitle: this.props.pollTitle,
            numberOfVotes: 0,
            votedList: []

        }

        this.updateOption.bind(this)
    }

    componentDidMount() {
        this.getOptions()

    }

    voteNow = async (pollOptionId) => {
        return await new Promise((resolve, reject) => {
            fetch("/api/poll/vote", {
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    postID: this.props.postID,
                    pollOptionId: pollOptionId,
                    uid: this.props.auth.uid,
                })
            }).then((res) => res.json()).then((finalResponse) => {
                if (finalResponse.success) {

                    resolve({
                        success: true
                    })
                }
            })
        })
    }

    getOptions = async () => {
        const key = this.props.postID
        db.collection('Post')
            .doc(key)
            .collection('PollOption')
            .onSnapshot(function (querySnapshot) {
                let allPollOption = []
                querySnapshot.forEach(function (doc) {
                    const PollOption = {
                        id: doc.id,
                        count: doc.data().count,
                        optionName: doc.data().optionName
                    }
                    allPollOption.push(PollOption)
                })
                this.updateOption(allPollOption)
            }.bind(this))
        db.collection("Post")
            .doc(key)
            .onSnapshot((doc) => {
                let voteList = doc.data().votedMember;
                let numberOfVotes = doc.data().numberOfVotes;
                this.setState({
                    numberOfVotes: numberOfVotes,
                    votedList: voteList
                }, () => {

                })
            })

    }

    updateOption = (getState) => {
        if (getState.data !== null) {
            const chartData = [['Polls', 'Number of Votes']]
            getState.map(e => {
                chartData.push([e.optionName, e.count])
            })
            this.setState({
                pollOption: getState,
                chartData: chartData
            }, () => {
                this.setState({
                    isLoaded: true
                })
            })
        }
    }

    updatePoll = pollObj => {
        this.setState({
            numberOfVotes: pollObj.numberOfVotes
        })
    }

    render() {
        return (
            <div className={classes.DisplayCard}>
                <div className={classes.PollPreviewTitle}>
                    <div>
                        <h6>{this.state.pollTitle}</h6>

                        <Badge color="light">{this.state.numberOfVotes} 人投了票</Badge>
                    </div>
                </div>
                <div className={classes.PollPreviewMain}>
                    {/*<MDBBtnGroup>*/}
                    {
                        isAuth(this.props.auth) ?
                            this.state.pollOption.map((e, index) => {
                                return (
                                    <MDBBtn
                                        color='link'
                                        className={classes.Option}
                                        disabled={(this.state.votedList ? this.state.votedList.includes(this.props.auth.uid) : false)}
                                        onClick={(ev) => {
                                            this.setState({
                                                voted: true
                                            })
                                            this.voteNow(e.id)
                                        }}>
                                        <span className={classes.OptionName}>
                                            {e.optionName}
                                        </span>
                                        {
                                            (this.state.votedList ? this.state.votedList.includes(this.props.auth.uid) : false) ?
                                                <Badge color="light">{e.number}</Badge>
                                                :
                                                ''
                                        }
                                    </MDBBtn>
                                )
                            }) :
                            <MDBAlert color="secondary">
                                <Link to={'/login'}>
                                    登入以參與投票及觀看投票結果
                                </Link>
                            </MDBAlert>
                    }
                    {/*</MDBBtnGroup>*/}
                    {
                        this.state.voteSuccess ?
                            <Alert color="success">
                                投票完成
                            </Alert>
                            :
                            typeof this.state.votedList !== 'undefined' && (this.state.votedList ? this.state.votedList.includes(this.props.auth.uid) : false) ?
                                <Alert color="danger">
                                    你已經投過票了
                                </Alert>
                                : ''
                    }
                </div>
                <div>
                    {
                        this.state.isLoaded && ((this.state.votedList ? this.state.votedList.includes(this.props.auth.uid) : false) || this.state.voteSuccess) ?
                            <Chart
                                width={'100%'}
                                height={'400px'}
                                chartType="PieChart"
                                loader={<div>Loading Chart</div>}
                                data={this.state.chartData}
                                options={{
                                    title: this.props.pollTitle,
                                }}
                                rootProps={{'data-testid': '1'}}
                            />
                            : ''
                    }
                </div>
            </div>
        );
    }
}

export default PollDisplay